export default "__VITE_ASSET__dxKtmeko__"